import {
	SET_ORGANISATION_LIST,
	SET_ADMIN_SYSTEM_ROLES,
	SET_ADMIN_SYSTEM_ROLE_DATA,
	ADD_ADMIN_SYTEM_ROLE,
	SERVER_GET_ADMIN_SYSTEM_ROLES,
	SERVER_GET_ADMIN_SYSTEM_ROLE_DATA,
	SERVER_UPDATE_ADMIN_SYSTEM_ROLE_DATA,
	SERVER_ADD_ADMIN_SYSTEM_ROLE,
	SERVER_DELETE_ADMIN_SYSTEM_ROLE,
	SERVER_GET_ORGANISATION_LIST,
	UPDATE_ADMIN_SYSTEM_ROLE_DATA_SUCCESS,
	UPDATE_ADMIN_SYSTEM_ROLE_DATA_ERROR,
	ADD_ADMIN_SYSTEM_ROLE_ERROR,
	DELETE_ADMIN_SYSTEM_ROLE_SUCCESS,
	DELETE_ADMIN_SYSTEM_ROLE_ERROR,
	SIGNOUT_USER,
	SET_ORGANISATION_LIST_FILTER,
	SET_ORGANISATION_TABLE_PAGE,
	SET_AFFILIATED_ORGANISATIONS,
	SERVER_GET_AFFILIATED_ORGANISATIONS
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	organisations: [],
	systemRoles: [],
	systemRoleData: {
		roleId: 0,
		name: null,
		description: null,
		data: []
	},
	loading: {
		organisations: false,
		systemRoles: false,
		systemRoleData: false,
		systemRoleDataUpdate: false,
		systemRoleAdd: false,
		systemRoleDelete: false,
		affiliatedOrganisations: false
	},
	organisationListFilter: [],
	organisationTablePage: 0,
	organisationsMapSelectedOrganisations: {
		organisationId: null,
		affiliatedOrganisations: []
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_ORGANISATION_LIST:
			return {
				...state,
				organisations: action.payload.organisations.map(organisation => {
					return {
						...organisation,
						paths: organisation.path
							? organisation.path.map(path =>
									path.map(coordinates => {
										return {
											lat: coordinates[0],
											lng: coordinates[1]
										};
									})
							  )
							: []
					};
				}),
				loading: {
					...state.loading,
					organisations: false
				}
			};
		case SET_ADMIN_SYSTEM_ROLES:
			return {
				...state,
				systemRoles: action.payload.systemRoles,
				loading: { ...state.loading, systemRoles: false }
			};
		case SET_ADMIN_SYSTEM_ROLE_DATA:
			return {
				...state,
				systemRoleData: action.payload.systemRoleData,
				loading: { ...state.loading, systemRoleData: false }
			};
		case ADD_ADMIN_SYTEM_ROLE:
			return {
				...state,
				systemRoles: [...state.systemRoles, action.payload.systemRole],
				loading: { ...state.loading, systemRoleAdd: false }
			};
		case SERVER_GET_ADMIN_SYSTEM_ROLES:
			return {
				...state,
				loading: { ...state.loading, systemRoles: true }
			};
		case SERVER_GET_ADMIN_SYSTEM_ROLE_DATA:
			return {
				...state,
				systemRoleData: INITIAL_STATE.systemRoleData,
				loading: { ...state.loading, systemRoleData: true }
			};
		case SERVER_UPDATE_ADMIN_SYSTEM_ROLE_DATA:
			return {
				...state,
				loading: { ...state.loading, systemRoleDataUpdate: true }
			};
		case SERVER_ADD_ADMIN_SYSTEM_ROLE:
			return {
				...state,
				loading: { ...state.loading, systemRoleAdd: true }
			};
		case SERVER_DELETE_ADMIN_SYSTEM_ROLE:
			return {
				...state,
				loading: { ...state.loading, systemRoleDelete: true }
			};
		case SERVER_GET_ORGANISATION_LIST:
			return {
				...state,
				loading: { ...state.loading, organisations: true }
			};
		case UPDATE_ADMIN_SYSTEM_ROLE_DATA_SUCCESS:
		case UPDATE_ADMIN_SYSTEM_ROLE_DATA_ERROR:
			return {
				...state,
				loading: { ...state.loading, systemRoleDataUpdate: false }
			};
		case ADD_ADMIN_SYSTEM_ROLE_ERROR:
			return {
				...state,
				loading: { ...state.loading, systemRoleAdd: false }
			};
		case DELETE_ADMIN_SYSTEM_ROLE_SUCCESS:
		case DELETE_ADMIN_SYSTEM_ROLE_ERROR:
			return {
				...state,
				loading: { ...state.loading, systemRoleDelete: false }
			};
		case SET_ORGANISATION_LIST_FILTER:
			return {
				...state,
				organisationListFilter: action.payload.filter
			};
		case SET_ORGANISATION_TABLE_PAGE:
			return { ...state, organisationTablePage: action.payload.page };
		case SERVER_GET_AFFILIATED_ORGANISATIONS:
			return {
				...state,
				organisationsMapSelectedOrganisations: { organisationId: action.payload.organisationId, affiliatedData: [] },
				loading: { ...state.loading, affiliatedOrganisations: true }
			};
		case SET_AFFILIATED_ORGANISATIONS:
			return {
				...state,
				organisationsMapSelectedOrganisations: {
					...state.organisationsMapSelectedOrganisations,
					affiliatedData: action.payload.affiliations
				},
				loading: { ...state.loading, affiliatedOrganisations: false }
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/SystemSettings.js